import './preprocessObsidian';
import './preprocessObsidianFgTerrain';
import { useRef, useCallback } from 'react';
import { PerspectiveCamera } from '@react-three/drei';
import { parallax } from '@immutabl3/alchemy';
import { useAsset } from '@artica/assets';
import {
  useSetRef,
  useManagedAnimations,
} from '@artica/hooks';

const CAMERA_SCALE = 0.22; // camera cuts off at approx 22%

export default function ObsidianCamera() {
  const group = useRef();
  const { animations } = useAsset('obsidian');
  const { actions } = useManagedAnimations(animations, group);

  const onPercChange = useCallback(perc => {
    const animation = actions?.animation_0;
    if (!animation) return;
    const mixer = animation.getMixer();
    const { duration } = animation.getClip();
    const sec = duration * perc * CAMERA_SCALE;
    mixer.setTime(sec);
  }, [actions]);

  return (
    <parallax.group
      ref={ group }
      dispose={ null }
      
      beaker="chapter3"
      onPercChange={ onPercChange }
    >
      <PerspectiveCamera
        name="Camera"
        ref={ useSetRef('obsidiancamera') }
        makeDefault={ true }
        far={ 50000 }
        near={ 1 }
        fov={ 43.6 }
      />
    </parallax.group>
  );
};